import { CmsObjectWithDefault } from '@components/Cms/types';

export type PasskeyListCmsKey = 'Header' | 'SubHeader';

export const PasskeyListCmsWithDefault: CmsObjectWithDefault<PasskeyListCmsKey> = {
    Header: {
        cmsId: 553053,
        defaultTranslation: 'Your passkey {0}',
    },
    SubHeader: {
        cmsId: 553054,
        defaultTranslation: 'Your devices',
    },
};
